import React from 'react'
import Radium from 'radium'
import { semanticColors } from '../../../Globals/styles'

const Cell = ({ content, style, inputStyle, readOnly, onChange, onFocus, onFocusOut, onClick, inputClassName, children, ref }) => {
    return (
        <div style={[styles.cell, style]}
            onClick={() => { onClick ? onClick() : {} }}>
            <input
                className={inputClassName}
                ref={ref ? ref : undefined}
                type="text"
                value={content}
                readOnly={readOnly ? readOnly : false}
                style={[styles.input, inputStyle]}
                onChange={(e) => {
                    if (onChange) {
                        onChange(e.target.value)
                    }
                }}
                onFocus={() => onFocus ? onFocus() : {}}
                onBlur={() => onFocusOut ? onFocusOut() : {}}
            />
            {children}
        </div>
    );
}

const styles = {
    cell: {
        flexGrow: 0,
        flexShrink: 0,
        verticalAlign: 'top',
    },
    input: {
        outline: 'none',
        borderRadius: 0,
        '-webkit-box-shadow': 'none',
        '-moz-box-shadow': 'none',
        'box-shadow': 'none',
        ':focus': {
            outline: 'none',
            borderBottom: '1px solid ' + 'white',
        }
    }
}

export default Radium(Cell);


// WEBPACK FOOTER //
// ./src/App/APV/spreadsheets/table/cell.js